import React from 'react';
import PropTypes from 'prop-types';

import IString from '../../common/components/i-string';
import { serverToQueryString } from '../../common/util/server-util';

function LoginFormContainer(props) {
  const { children } = props;

  const query = serverToQueryString(true);

  return (
    <div className='fullPageFormContainer marginAbove'>
      <div className='splitFormHeader'>
        <div className='flex flexAlignBottom'>
          <h2 className='loginActive formTitle'><IString stringKey='general.title.login' /></h2>
          <a href={`/register${query}`} className='alternateFormPicker noLink signupLink'>
            <div className='alternateFormText'>
              <IString stringKey='general.title.alt' />
            </div>
            <div className='alternateFormTitle'>
              <IString stringKey='general.title.register' />
            </div>
          </a>
        </div>
      </div>

      { children }
      
    </div>
  );
}

LoginFormContainer.propTypes = {
  children: PropTypes.node
};

export default LoginFormContainer;
